module.exports = __webpack_public_path__ + "static/media/virgin-dark.579a9a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AirlineLogo/images/logos/virgin-dark.png
// module id = 787
// module chunks = 0